import {
  type GraphView,
  type GraphViewPreviewable,
  date,
} from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import { useLocale } from 'containers/App/LocaleContext';
import type { FC } from 'react';
import { useDateTimeFormat } from 'utils/hooks/useDateTimeFormat';
import { useTimezone } from 'utils/hooks/useTimeZone';
import { getTextBreadcrumbs } from '../GraphBreadcrumbs/helpers/breadcrumbsText';
import { useGraphBreadcrumbs } from '../GraphBreadcrumbs/useGraphBreadcrumbs';
import { useGraphContextSelectors } from '../GraphContext';

interface Props {
  view: GraphView | GraphViewPreviewable;
}

export const SaveViewConfirmDialogBody: FC<Props> = (props) => {
  const dateTimeFormat = useDateTimeFormat();
  const timezone = useTimezone();
  const msg = useLocale();
  const ctxProps = useGraphContextSelectors({
    snapshotId: prop('snapshotId'),
  });

  const breadcrumbs = useGraphBreadcrumbs(
    props.view.parameters,
    ctxProps.snapshotId,
    props.view.overlay ?? null,
    null,
  );

  const breadcrumbsText = getTextBreadcrumbs(breadcrumbs, msg);

  return (
    <div className='mt-2.5'>
      <div className='graph-save-view__view-name'>{props.view.name}</div>
      <div className='graph-save-view__view-info-text'>{breadcrumbsText}</div>
      <div className='graph-save-view__view-info-text'>
        {date.formatUtcTimestampInTimeZone(
          props.view.savedAt,
          timezone,
          dateTimeFormat,
        )}
      </div>
    </div>
  );
};
